export const defaultTableConfig = {
	enableStickyHeader: true,
	muiBottomToolbarProps: {
		sx: {
			boxShadow: "unset !important",
			"> div": {
				justifyContent: "center",
				shadow: "unset",
				paddingBottom: 2,
				"> div": {
					position: "relative",
					"> div": {
						paddingBottom: 0,
					},
				},
			},
		},
	},
};
